export enum PaymentTypes {
  MERCADO_PAGO_PRO = 'MERCADO_PAGO_PRO',
  MERCADO_PAGO_CARD = 'MERCADO_PAGO_CARD',
  MERCADO_PAGO_PIX = 'MERCADO_PAGO_PIX',
  PAGBANK_CARD = 'PAGBANK_CARD',
  PAGBANK_PIX = 'PAGBANK_PIX',
  PAGOS_TERPEL = 'PAGOS_TERPEL',
  WALLET = 'WALLET',
  MANUAL_DASHBOARD = 'MANUAL_DASHBOARD',
  VOUCHER = 'VOUCHER',
  TICKET_LOG = 'TICKET_LOG',
}

export enum NFEStatus {
  ERROR_CS = 'error_cs',
  ERROR_DISABLE_OR_NOT_CONFIGURED = 'error_disabled_or_not_configured',
  ERRO_CANCELAMENTO = 'erro_cancelamento',
  PROCESSANDO_AUTORIZACAO = 'processando_autorizacao',
  AUTORIZADO = 'autorizado',
}
export interface ITransaction {
  autonomy: number;
  chargeBoxDescription: string;
  chargeBoxId: string;
  chargeBoxPk: number;
  connectorId: number;
  connectorPk: number;
  cost: number;
  costHumanReadable: string;
  duration: number;
  durationTime: string;
  energy: number;
  energyHumanReadable: string;
  environIndicator: number;
  id: number;
  income: number;
  incomeHumanReadable: string;
  km: number;
  kmKWh: number;
  kmTarget: number;
  moneyPerKilowattCost: null;
  moneyPerKilowattIncome: number;
  ocppIdTag: string;
  ocppTagPk: number;
  paymentType: PaymentTypes;
  startTimestamp: string;
  startTimestampDT: {
    year: number;
    dayOfMonth: number;
    dayOfWeek: number;
    dayOfYear: number;
    era: number;
    millisOfDay: number;
  };
  startValue: string;
  stopEventActor: null;
  nfeStatus: NFEStatus | null;
  stopReason: null;
  stopTimestamp: string;
  stopTimestampDT: {
    year: number;
    dayOfMonth: number;
    dayOfWeek: number;
    dayOfYear: number;
    era: number;
    millisOfDay: number;
  };
  stopValue: number;
  stationTenantAlias: string;
  voucherUnitPk?: number;
  userTenantAlias: string;
  userName: string;
  durationHumanReadable: string;
  feedbackStars: number;
  feedbackDescription: string;
  idleDurationHumanReadable: string;
  idleDuration: number;
  moneyIdlePaymentTransactionAmount: number;
  moneyIdlePaymentTransactionAmountHumanReadable: string;
  transactionAmount: number;
  transactionAmountHumanReadable: string;
  transactionAmountAvailable: number;
  transactionAmountAvailableHumanReadable: string;
  userCompany: string;
  addressState: string;
  addressCity: string;
  userEmail?: string;
  userPhone?: string;
  origin?: string;
  paymentStatusDetail?: string;
  paymentStatus?: string;
  statusBtoB?: string;

  /**
   * MV2-1802: PAID / UNPAID / PRICELESS decidido pelo CS, pelas mesmas condições do filtro da
   * listagem. Ver utils/paymentSituation.
   */
  paymentSituation?: string;
}
